import Signaler from 'signalerjs';
import features from '../constants/FeatureFlags';

export type FeatureFlags = {
  [testName: string]: {
    flags: {
      [flagName: string]: number;
    };
  };
};

const signaler = new Signaler(features);

export default signaler;
